@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";
@use "foundation/_mixins.scss";

$input-border-radius: 0.5em;

.cta {
  display: flex;
  align-items: center;
}

.answers {
  margin-bottom: 0.83em;
}

.option {
  margin: 8px;
  width: 7em;
}

.like,
.dislike {
  background-color: colors.$primary-text-color;
  border-color: colors.$primary-text-color;
  color: #fff;
}

.form-option {
  padding: 1em 0;
}

.applet-feedback-form {
  input[type="radio"] {
    display: none;

    &:checked {
      + label {
        position: relative;
      }

      + label::after {
        background-color: colors.$primary-text-color;
      }
    }

    + label {
      line-height: 1.25;
      padding-left: 3em;
      padding-top: 0;
      position: relative;
      cursor: pointer;

      &::before {
        border: 4px solid colors.$primary-eerie-black;
        border-radius: 2em;
        content: "";
        height: 2em;
        left: 0;
        position: absolute;
        top: -0.5em;
        width: 2em;
      }

      &::after {
        border-radius: 1em;
        content: "";
        height: 1em;
        left: 0.5em;
        position: absolute;
        top: 0;
        width: 1em;
      }
    }

    &:disabled {
      opacity: 0.5;

      + label {
        opacity: 0.5;
      }
    }
  }

  &.submitted {
    input,
    keygen,
    select,
    textarea {
      &:invalid {
        border: solid 6px colors.$error-color;
      }
    }
  }

  // Hide the recaptcha badge.
  .grecaptcha-badge {
    opacity: 0.05;
  }
}

.textarea-wrapper {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  color: colors.$tertiary-text-color;
}

.text-counter {
  position: absolute;
  margin-right: 1em;
  margin-bottom: 1em;
  color: colors.$tertiary-text-color;
  font-size: .8em;
}

.feedback-ui {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.dialogue {
  background-color: colors.$input-background-color;
  width: 90%;
  border-radius: 0.5em;
  padding: 1.777777777em;

  .submit-button {
    display: block;
    margin: 1.333333333em auto 0em;
  }

  textarea {
    @include mixins.placeholder(colors.$tertiary-text-color);
    border: none;
    padding: 0.5em 0.75em;
    width: 100%;
    font-size: 1.11111111rem;
    height: 6em;
    resize: none;

    &:disabled {
      opacity: 0.5;
    }
  }
}

.thanks {
  background-color: colors.$input-background-color;
  width: 90%;
  border-radius: 0.5em;
  padding: 0.888888888em 1.777777777em;
}

.prompt {
  margin-bottom: 1em;
  line-height: 1.333333333em;
}

